<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container" :style="{height: contentHeight}">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ confirm }}
        </div>
        <div
          class="modal_body"
          :style="{textAlign: textAlign, height: bodyHeight}"
        >
          <div class="body" v-html="question"></div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['question'],
  data() {
    return {
      caution: require('../../../../img/caution.png'),
      confirm: '確認',
      okButton: 'OK'
    }
  },
  computed: {
    contentHeight() {
      if (this.question.length >= 92) {
        return '280px'
      } else if (
        this.question === '追加しました。' ||
        this.question === 'エクスポートしました。' ||
        this.question === 'インポートしました。' ||
        this.question === 'パスワードを初期化しました。' ||
        this.question === '終了しました。' ||
        this.question.slice(-7) === '削除しました。' ||
        this.question.slice(-7) === '変更しました。'
      ) {
        return '205px'
      } else {
        return '240px'
      }
    },
    textAlign() {
      if (
        this.question === '追加しました。' ||
        this.question === 'エクスポートしました。' ||
        this.question === 'インポートしました。' ||
        this.question === 'パスワードを初期化しました。' ||
        this.question === '終了しました。' ||
        this.question.slice(-7) === '削除しました。' ||
        this.question.slice(-7) === '変更しました。'
      ) {
        return 'center'
      } else {
        return 'left'
      }
    },
    bodyHeight() {
      if (this.question.length >= 92) {
        return '285px'
      } else {
        return '157px'
      }
    }
  },
  methods: {
    close(e) {
      if (this.question.slice(0, 10) === 'MSGCRD0001') {
        // this.$router.push('/master/Pages')
        // this.$store.dispatch('systemAdminDefine/successLogoutFlag')
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
}
.modal_header {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/finishModalWindow.vue